import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import api from '@/lib/api';
import { Shield, Heart, Briefcase, Building2, Home, Gavel } from 'lucide-react';

const iconMap = { Shield, Heart, Briefcase, Building2, Home, Gavel };
const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };
const stagger = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } };

export default function ServicesPage() {
  const { t, language } = useLanguage();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get('/services').then(r => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="services-page">
      <section className="py-24 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-[#C5A059] text-xs uppercase tracking-[0.3em] font-medium">{language === 'tr' ? 'Hizmetlerimiz' : 'Our Services'}</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F3F4F6] mt-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{t('services.title')}</h1>
          <p className="text-[#A1A1AA] mt-4 max-w-xl mx-auto">{t('services.subtitle')}</p>
        </div>
      </section>
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial="hidden" animate="visible" variants={stagger} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((svc, i) => {
              const Icon = iconMap[svc.icon] || Shield;
              return (
                <motion.div key={svc.id || i} variants={fadeUp} className="p-8 bg-[#121212] border border-white/10 rounded-sm card-hover group" data-testid={`service-item-${i}`}>
                  <div className="w-14 h-14 flex items-center justify-center bg-[#C5A059]/10 rounded-sm mb-6 group-hover:bg-[#C5A059]/20 transition-colors"><Icon className="h-7 w-7 text-[#C5A059]" /></div>
                  <h3 className="text-2xl font-semibold text-[#F3F4F6] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{language === 'tr' ? svc.title_tr : svc.title_en}</h3>
                  <p className="text-[#A1A1AA] text-sm leading-relaxed mb-4">{language === 'tr' ? svc.description_tr : svc.description_en}</p>
                  <p className="text-[#A1A1AA]/70 text-sm leading-relaxed">{language === 'tr' ? svc.detail_tr : svc.detail_en}</p>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
